(function () {
  const wrap = document.getElementById("navbar-wrap");
  if (!wrap) return;

  const mode = (wrap.getAttribute("data-sticky") || "none").trim();
  let lastY = window.scrollY - 1;
  let ticking = false;

  function update() {
    const y = window.scrollY;

    if (mode === "reveal") {
      if (y < 8) {
        wrap.classList.add("is-visible");
      } else if (y > lastY + 2) {
        // Aşağı scroll: tam gizle
        wrap.classList.remove("is-visible");
      } else if (y < lastY - 2) {
        // Yukarı scroll: göster
        wrap.classList.add("is-visible");
      }
    } else if (mode === "sticky") {
      wrap.classList.toggle("is-scrolled", y > 8);
    }

    lastY = y;
    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(update);
    }
  }

  window.addEventListener("scroll", onScroll, { passive: true });

  const closeBtn = document.querySelector("[data-announcement-close]");
  if (closeBtn) {
    closeBtn.addEventListener("click", () => {
      closeBtn.closest(".announcement")?.classList.add("is-hidden");
    });
  }

  update();
})();

(function () {
  const panel = document.querySelector("[data-search-panel]");
  if (!panel) return;

  const toggles = document.querySelectorAll("[data-search-toggle-open]");
  const input = panel.querySelector("[data-search-input]");
  const results = panel.querySelector("[data-search-results]");
  let debounceTimer;
  let activeQuery = "";
  let currentRequest;
  let requestSeq = 0;

  function setOpen(open) {
    panel.classList.toggle("is-open", open);
    panel.setAttribute("aria-hidden", open ? "false" : "true");
    if (open && input) {
      requestAnimationFrame(() => input.focus());
    } else {
      hideResults();
    }
  }

  function escapeHtml(value) {
    return (value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function formatMoney(value) {
    if (typeof value !== "number") return "";
    if (window.HrcFormatMoney) {
      return window.HrcFormatMoney(value, { forceDecimals: true });
    }
    const abs = Math.round(Math.abs(value));
    const grouped = String(Math.floor(abs / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return `${grouped},${String(abs % 100).padStart(2, "0")}TL`;
  }

  function hideResults() {
    if (!results) return;
    results.hidden = true;
    results.innerHTML = "";
  }

  function renderProducts(items, query) {
    if (!results) return;

    if (!items.length) {
      results.innerHTML = `<p class="search__empty">"${escapeHtml(query)}" icin urun bulunamadi.</p>`;
      results.hidden = false;
      return;
    }

    const productItems = items
      .slice(0, 8)
      .map((item) => {
        const cents =
          typeof item.price === "number" ? item.price : Number(item.price) * 100;
        const price = formatMoney(cents);
        const isB2B = window.HrcB2B?.isCustomer?.();
        const priceHtml = !price
          ? ""
          : isB2B && typeof window.HrcB2B?.priceMarkup === "function"
          ? `<span class="search__result-price price" data-hrc-clay-price data-product-id="${escapeHtml(String(item.product_id || item.id || ""))}" data-base-price="${escapeHtml(String(Math.round(cents)))}">${window.HrcB2B.priceMarkup({
              productId: item.product_id || item.id || "",
              catalogText: price,
              currentClass: "search__result-price",
              compareClass: "search__result-price-old",
            })}</span>`
          : `<span class="search__result-price">${price}</span>`;
        const imageUrl =
          item.image ||
          item.featured_image?.url ||
          (typeof item.featured_image === "string" ? item.featured_image : "");
        const image = imageUrl
          ? `<img src="${imageUrl}" alt="${escapeHtml(item.title)}" class="search__result-image" loading="lazy">`
          : '<span class="search__result-image search__result-image--placeholder" aria-hidden="true"></span>';

        return `
          <a href="${item.url}" class="search__result-item">
            ${image}
            <span class="search__result-meta">
              <span class="search__result-title">${escapeHtml(item.title)}</span>
              ${priceHtml}
            </span>
          </a>
        `;
      })
      .join("");

    results.innerHTML = `
      <div class="search__result-list">${productItems}</div>
      <a href="/search?q=${encodeURIComponent(query)}&type=product&options%5Bprefix%5D=last" class="search__result-all">Tum sonuclari gor</a>
    `;
    results.hidden = false;
    window.HrcB2B?.notifyPricingApps?.(results);
  }

  async function fetchPredictiveResults(query) {
    if (!results) return;
    if (currentRequest) currentRequest.abort();
    currentRequest = new AbortController();
    const seq = ++requestSeq;

    const params = new URLSearchParams({
      q: query,
      "resources[type]": "product",
      "resources[limit]": "8",
      "resources[options][unavailable_products]": "last",
      "resources[options][fields]":
        "title,product_type,variants.title,vendor,tag",
    });

    try {
      const response = await fetch(
        `/search/suggest.json?${params.toString()}`,
        {
          signal: currentRequest.signal,
          headers: { Accept: "application/json" },
        },
      );
      if (!response.ok)
        throw new Error(`Search request failed: ${response.status}`);
      const payload = await response.json();
      if (seq !== requestSeq) return;
      const items = payload?.resources?.results?.products || [];

      activeQuery = query;
      renderProducts(items, query);
    } catch (error) {
      if (error.name === "AbortError") return;
      if (seq !== requestSeq) return;
      hideResults();
    }
  }

  function onInput() {
    const query = (input && input.value ? input.value : "").trim();

    clearTimeout(debounceTimer);
    if (!query || query.length < 2) {
      activeQuery = "";
      if (currentRequest) currentRequest.abort();
      hideResults();
      return;
    }

    if (query === activeQuery && results && !results.hidden) {
      return;
    }

    debounceTimer = setTimeout(() => {
      fetchPredictiveResults(query);
    }, 180);
  }

  toggles.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      const willOpen = !panel.classList.contains("is-open");
      setOpen(willOpen);
    });
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && panel.classList.contains("is-open")) {
      setOpen(false);
    }
  });

  if (input) {
    input.addEventListener("input", onInput);
  }
})();

(function () {
  const items = document.querySelectorAll(".navbar__nav-item--mega");
  if (!items.length) return;

  items.forEach((item) => {
    const trigger = item.querySelector(".navbar__nav-link");
    const panel = item.querySelector("[data-mega]");
    if (!trigger || !panel) return;

    let closeTimer = 0;

    function openMega() {
      items.forEach((other) => {
        if (other === item) return;
        const otherPanel = other.querySelector("[data-mega]");
        const otherTrigger = other.querySelector(".navbar__nav-link");
        otherPanel?.setAttribute("aria-hidden", "true");
        otherTrigger?.setAttribute("aria-expanded", "false");
      });
      window.clearTimeout(closeTimer);
      panel.setAttribute("aria-hidden", "false");
      trigger.setAttribute("aria-expanded", "true");
    }

    function closeMega() {
      panel.setAttribute("aria-hidden", "true");
      trigger.setAttribute("aria-expanded", "false");
    }

    function closeMegaSoon() {
      closeTimer = window.setTimeout(closeMega, 140);
    }

    item.addEventListener("mouseenter", openMega);
    item.addEventListener("mouseleave", closeMegaSoon);
    trigger.addEventListener("focus", openMega);
    panel.addEventListener("focusin", openMega);

    item.addEventListener("focusout", (event) => {
      if (!item.contains(event.relatedTarget)) closeMegaSoon();
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") closeMega();
    });
  });
})();
